import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    grafanaUrl: null,
    user: false,
    device: null,
    stayLogged: false,
    websocket: null,
    applications: [],
    application: {},
    devices: [],
    tilesTable: [],
    alertTable: [],
    devicesForMapMarkers: [],
    isAdmin: false,
    websocketClosed: false,
    contentMenuItems: [],
    contentMenuData: {
      menuTitle: null,
      applicationId: null,
      menuFirstItemId: null,
      // eslint-disable-next-line
      menuItems: null,
    },
    filterData: [],
    account: null,
    // eslint-disable-next-line
    accountId: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAdmin = user.type === "admin" ? true : false;
    },
    setAccount(state, account) {
      state.account = account;
    },
    setAccountId(state, accountId) {
      state.accountId = accountId;
      // eslint-disable-next-line
    },
  },
  // eslint-disable-next-line
  actions: {},
});
